export default __webpack_public_path__ + "static/media/qrcode.4cf1e5b7.svg";